import { Link } from 'react-router-dom';

import ProductCard from '../product-card/product-card.component';

import './category-preview.styles.scss';

// with firebase

function CategoryPreview({ title, products }) {
  return (
    <div className="category-preview-container">
      <h2>
        <Link className="title" to={title}>
          {title.toUpperCase()}
        </Link>
      </h2>
      <div className="preview">
        {products
          .filter((_, idx) => idx < 4)
          .map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
      </div>
    </div>
  );
}

/////////////////////////////////////////////////
// without firebase

// function CategoryPreview({ title, products }) {
//   const arr = ['hats', 'sneakers', 'jackets', 'womens', 'mens'];
//   return (
//     <div className="category-preview-container">
//       <h2>
//         <Link className="title" to={arr[title]}>
//           {arr[title].toUpperCase()}
//         </Link>
//       </h2>
//       <div className="preview">
//         {products.items
//           .filter((_, idx) => idx < 4)
//           .map((product) => (
//             <ProductCard key={product.id} product={product} />
//           ))}
//       </div>
//     </div>
//   );
// }

export default CategoryPreview;
